import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { TagCampoEnum } from '@appNeo/neoShared/helpers/enums/TagCampo.enum';
import { TipoDatePickerEnum } from '@appNeo/neoShared/helpers/enums/TipoDatePicker.enum';
import { ClasesFormularioAnchoEnum, IFormInput } from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { FormularioService } from '@appNeo/neoShared/services/formulario/formulario.service';
import { format } from 'date-fns';
import { FormularioComponent } from '../formulario/formulario.component';

@Component({
  selector: 'neo-formulario-array[inputsFormulario]',
  templateUrl: './formulario-array.component.html',
  styleUrls: ['./formulario-array.component.scss'],
  providers: [FormularioService],
  encapsulation: ViewEncapsulation.None
})
export class FormularioArrayComponent implements OnInit {

  valoresFormulariosArray: any[] = [];
  // GestionarBloqueosCalendario: dialogo para bloquear fechas por rangos
  @ViewChild('formularioSemillaArray') formularioSemillaArray: FormularioComponent;
  @ViewChildren(FormularioComponent) formulariosArray: QueryList<FormularioComponent>;
  @Input() inputsFormulario;
  @Input() valoresFormulariosIniciales: any[] = [];
  @Input() aplicarFlex: boolean = true;
  @Input() clasesFormularioAnchoEnum = ClasesFormularioAnchoEnum.formularioAnchoCompleto;
  @Input() colorBotonAnhadir = 'primary';
  @Input() identificadorPadre = 'primary';
  @Input() permitirAnhadir = true;
  @Input() permitirEliminar = true;
  @Output() cambioElementos = new EventEmitter<any[]>();
  inputsFormularioArr = [];
  constructor(
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
    console.log('COMPONENTE FORMULARIO ARRAY');
    this.valoresFormulariosArray = Object.assign([], this.valoresFormulariosIniciales);
    this.componerArrCampos();
  }
  componerArrCampos() {
    this.valoresFormulariosArray.forEach(item => {
      let configuracionCampos = JSON.parse(JSON.stringify(this.inputsFormulario)); // Copia profunda para evitar modificar el original

      // [{formControlName: [{propiedad:X, value:x }]}
      if (item.hasOwnProperty('camposFormulario_extension') && item.camposFormulario_extension.length > 0) {        
        item.camposFormulario_extension.forEach(extension => {
            // Iterar sobre cada propiedad del `camposFormulario_extension`
            Object.keys(extension).forEach(campoKey => {
                const restricciones = extension[campoKey];

                // Buscar el campo correspondiente en la configuración del formulario
                const campoFormulario = configuracionCampos.find(f => f.formControlName === campoKey);
                
                if (campoFormulario) {
                    restricciones.forEach(({ propiedad, value }) => {
                        // Asignar la propiedad según la configuración
                        (campoFormulario as any)[propiedad] = value;
                    });
                }
            });
        });     
  
      }
      this.inputsFormularioArr.push(configuracionCampos);
    });
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log('CAMBIO EXTRAS ', changes);
    if (changes['valoresFormulariosIniciales'] && changes['valoresFormulariosIniciales'].currentValue) {
      console.log('valoresFormulariosIniciales cambio', this.valoresFormulariosIniciales , changes['valoresFormulariosIniciales'].currentValue);
      this.valoresFormulariosArray = Object.assign([], this.valoresFormulariosIniciales);
      this.componerArrCampos();
    }
  }
  onCambioFormulario(event, indice, id) {
    if (indice >= 0 && event?.campos?.length > 0) {
      let formulario = this.formulariosArray.find(item => item.identificador === id);
      formulario.formValueReset = true;
      let objeto = formulario.validaCampos(false);
      if ((objeto && objeto.formulario && objeto.formulario.valid)) {
        setTimeout(() => this.cambioElementos.emit(this.obtenerValoresRangos()));
      }
    }

  }

  onClickEliminar(indice, id) {
    if (this.valoresFormulariosArray[indice]) {
      this.valoresFormulariosArray.splice(indice, 1);
      setTimeout(() => this.cambioElementos.emit(this.obtenerValoresRangos()));
    }
  }

  onClickAnhadir() {
    if (this.formularioSemillaArray) {
      this.formularioSemillaArray.formValueReset = true;
      let objeto = this.formularioSemillaArray.validaCampos(false);
      if (objeto && objeto.formulario && objeto.formulario.valid) {

        this.valoresFormulariosArray.push(objeto.valores);
        let valid = true;
        Object.keys(objeto.valores).forEach((keyCampo) => {
          let confCampo: IFormInput = (this.formularioSemillaArray?.campos.find(campo => campo.formControlName == keyCampo));
          let esRango = confCampo.tag.includes(TagCampoEnum.Date) && confCampo.tipoDatePicker == TipoDatePickerEnum.FechaRango;
          if (esRango) {
            let rangoValido = this.auxiliarService.rangoValido(objeto.valores.rango.start._d, objeto.valores.rango.end._d);
            valid = valid && rangoValido;
            if (!rangoValido) {
              // TODO notificacion error
              console.warn('rangos no validos', objeto);
            }

          }
        });
        if (valid) {
          this.formularioSemillaArray.reset({});
          setTimeout(() => this.cambioElementos.emit(this.obtenerValoresRangos()));

        }
      } else {
        // TODO notificacion error
        console.warn('formulario semilla error', objeto);
        // this.grabando = false;
        // return;
      }
    } else {
      throw new Error("[ERROR FORMULARIO ARRAY] No detectado formulario semilla");
    }
  }

  obtenerValoresRangos(alias = 'formularioArray_') {
    let valoresFormulariosArray: any[] = [];
    this.formulariosArray.forEach(item => {
      if (item.identificador.indexOf(alias) >= 0) {
        item.formValueReset = true;
        let objeto = item.validaCampos(false);
        if ((objeto && objeto.formulario && objeto.formulario.valid)) {
          console.log(objeto.valores)
          let campoRango = {};
          if (objeto.valores?.rango) {
            campoRango = {
              desde: format(objeto.valores.rango.start._d, 'dd/MM/yyyy'),
              hasta: format(objeto.valores.rango.end._d, 'dd/MM/yyyy')
            }
          }
          let itemRango = {
            ...objeto.valores,
            ...campoRango
          };
          delete itemRango?.rango;
          itemRango['identificadorFormulario'] = item.identificador.slice(alias.length, item.identificador.length - 1);
          valoresFormulariosArray.push(itemRango);
        }
      }
    });
    return valoresFormulariosArray;
  }

}
